import SEOHead from '@/components/seo/SEOHead'
import HeroSection from '@/components/home/HeroSection'
import ShahadaSection from '@/components/islam/ShahadaSection'
import FeaturedBooks from '@/components/home/FeaturedBooks'
import JourneyToIslamCTA from '@/components/home/JourneyToIslamCTA'
import FAQsTiles from '@/components/home/FAQsTiles'
import RelaxationRadio from '@/components/home/RelaxationRadio'
import IntroCards from '@/components/home/IntroCards'
// import TopicGrid from '@/components/home/TopicGrid' // Hidden from client
import { useTranslation } from 'react-i18next'
import StoriesCarousel from '@/components/home/StoriesCarousel'

export default function HomePage() {
  const { t } = useTranslation()
  return (
    <>
      <SEOHead
        title={t('home.seo.title', 'سكينة - منصة إسلامية شاملة')}
        description={t('home.seo.description', 'سكينة منصة إسلامية شاملة تضم الكتب والقرآن وأوقات الصلاة والمزيد.')}
        canonical="/"
      />
      <div className="min-h-screen bg-gray-100 dark:bg-gray-900">
        {/* 1. Hero - First Impression */}
        <HeroSection />

        {/* 2. Intro Cards - Understanding Islam Basics */}
        <IntroCards />

        {/* 3. انطق بالشهادة - Enter Islam / Pronounce the Shahada */}
        <ShahadaSection />
        
        {/* 4. Stories Carousel - Emotional Connection & Inspiration */}
        <StoriesCarousel />
        
        {/* 5. Quran Radio - Spiritual Connection */}
        <RelaxationRadio src="https://stream.radiojar.com/8s5u5tpdtwzuv" forceLive />
           {/* 2. Journey to Islam CTA - Most Important (Dawah Priority) */}
        <JourneyToIslamCTA />
        
        {/* 6. Topic Grid - Services & Resources - Hidden from client */}
        {/* <TopicGrid /> */}
        
        {/* 7. Featured Books - Knowledge & Learning */}
        <FeaturedBooks />
        
        {/* 8. FAQs - Common Questions */}
        <FAQsTiles />
      </div>
    </>
  )
}
